module.exports = __webpack_public_path__ + "img/TEC_DE_MONTERREY.a76be0d4.png";